/* istanbul ignore file */
export * from './ProductListBreadcrumbs';
